
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Bushireserviceforpune() {



    const cardData =
    {
        keyword: 'Bus Hire Service for Pune Airport',
        heading: 'Amruta Travels: Bus Hire Service for Pune Airport',
        headingDescription: 'Amruta Travels offers Bus Hire Service for Pune Airport, providing reliable and comfortable transportation solutions for airport transfers. Whether you are organizing a corporate pickup, group arrival, or family drop-off, our well-maintained buses ensure a smooth and timely journey to and from Pune Airport. Choose from our range of buses, including 17-seater, 32-seater, and 50-seater options, to suit your group size. With experienced drivers, punctual service, affordable pricing, and 24/7 availability, Amruta Travels makes your airport transfers simple and stress-free. Book your airport bus with Amruta Travels and experience a journey of comfort and convenience!',


        top: 'Top Places to Visit in Pune Outstation with Amruta Travels',
"topPlaces": [
  {
    "title": "Lonavala & Khandala",
    "description": "Located approximately 66 km from Pune, these twin hill stations are nestled in the Sahyadri ranges. Known for their lush green valleys, waterfalls, and pleasant climate, they offer attractions like Bhushi Dam, Tiger's Leap, and Rajmachi Fort. Adventure enthusiasts can indulge in trekking, camping, and paragliding activities."
  },
  {
    "title": "Mahabaleshwar & Panchgani",
    "description": "Situated about 120 km from Pune, Mahabaleshwar is renowned for its strawberry farms, scenic viewpoints like Arthur's Seat, and the serene Venna Lake. Nearby Panchgani, at a distance of 100 km, offers attractions like Table Land and Parsi Point. Both hill stations provide a refreshing escape from city life."
  },
  {
    "title": "Matheran",
    "description": "Approximately 120 km from Pune, Matheran is India's smallest hill station and is unique for being a vehicle-free zone. Perched at an elevation of 800 meters, it offers panoramic views, colonial architecture, and 38 designated viewpoints, including Panorama Point and Louisa Point."
  },
  {
    "title": "Alibaug",
    "description": "Located around 140 km from Pune, Alibaug is a coastal town known for its clean beaches like Alibaug Beach and Nagaon Beach, as well as historical sites like Kolaba Fort. It's a popular destination for beach lovers and those seeking a tranquil seaside retreat."
  },
  {
    "title": "Kolad",
    "description": "Approximately 110 km from Pune, Kolad is famed for white-water rafting on the Kundalika River. The town also offers opportunities for kayaking, zip-lining, and camping, making it a haven for adventure seekers."
  },
  {
    "title": "Igatpuri",
    "description": "Situated about 240 km from Pune, Igatpuri is a hill station in the Western Ghats known for its misty mountains, waterfalls, and the Vipassana International Academy. It's an ideal spot for meditation, trekking, and enjoying nature's tranquility."
  },
  {
    "title": "Bhandardara",
    "description": "Located roughly 170 km from Pune, Bhandardara is a serene village offering attractions like the Bhandardara Lake, Randha Falls, and the historic Ratangad Fort. It's a perfect destination for nature lovers and those seeking solitude."
  },
  {
    "title": "Lavasa",
    "description": "Approximately 60 km from Pune, Lavasa is a planned city inspired by the Italian town of Portofino. It offers picturesque landscapes, water sports, and a range of dining options, making it a popular spot for weekend retreats."
  },
  {
    "title": "Goa",
    "description": "Situated about 450 km from Pune, Goa is India's premier beach destination. Known for its vibrant nightlife, Portuguese heritage, and sandy beaches like Baga and Anjuna, it offers a mix of relaxation and entertainment."
  },
  {
    "title": "Kaas Plateau",
    "description": "Around 140 km from Pune, the Kaas Plateau, also known as the 'Valley of Flowers of Maharashtra,' is a UNESCO World Natural Heritage site. During the monsoon season, it blooms with a variety of endemic flowers, attracting nature enthusiasts and photographers."
  }
],



 "services": [
    {
      "name": "Airport Bus Hire in Pune",
      "description": "Amruta Travels provides reliable airport bus hire services in Pune for comfortable and hassle-free airport transfers. Whether you need a transfer to or from Pune Airport, we offer a wide range of buses to suit your group size, ensuring timely and safe travel."
    },
    {
      "name": "Bus Rental For Airport Transfers Pune",
      "description": "Our bus rental services for airport transfers in Pune are designed to provide a comfortable, affordable, and convenient travel experience. We offer various bus sizes to accommodate any group, from small families to large corporate groups, ensuring efficient transfers to and from the airport."
    },
    {
      "name": "Hire a Bus for Airport Service Pune",
      "description": "Amruta Travels allows you to hire a bus for airport service in Pune. Our buses are equipped with modern amenities, air conditioning, and comfortable seating, making airport transfers smooth and relaxing for all passengers."
    },
    {
      "name": "Pune Airport Transfer Bus Rental",
      "description": "Book a bus for your airport transfer with Amruta Travels. We offer timely and reliable services for pick-ups and drop-offs, ensuring that you arrive at or leave the airport with ease. Our fleet includes various bus sizes, ideal for both small and large groups."
    },
    {
      "name": "Airport Pickup Bus Hire in Pune",
      "description": "Amruta Travels offers airport pickup bus hire services in Pune to ensure a smooth and efficient arrival. Our experienced drivers will meet you at the airport and transport your group comfortably to your destination, with a focus on punctuality and comfort."
    },
    {
      "name": "Airport Drop-off Bus Rental Pune",
      "description": "For airport drop-offs, Amruta Travels provides reliable and safe bus rental services. Whether it’s a corporate event or a family vacation, we ensure a comfortable journey from your location to Pune Airport, with flexible scheduling to suit your needs."
    },
    {
      "name": "26 Seater Bus for Airport Transfer Pune",
      "description": "For smaller groups, Amruta Travels offers a 26-seater bus for airport transfers in Pune. This bus is ideal for medium-sized groups, offering ample space and comfort for a smooth journey to and from the airport."
    },
    {
      "name": "25 Seater Airport Bus Rental Pune",
      "description": "Our 25-seater airport bus rental service in Pune is perfect for small groups looking for a comfortable and affordable way to travel to and from the airport. Enjoy the convenience of timely service, well-maintained buses, and experienced drivers."
    },
    {
      "name": "32 Seater Airport Bus Hire Pune",
      "description": "Amruta Travels offers a 32-seater airport bus hire in Pune for larger groups. This option is ideal for corporate events, family trips, or group tours, ensuring a spacious, air-conditioned, and comfortable ride to and from Pune Airport."
    },
    {
      "name": "50 Seater Bus for Airport Transfers Pune",
      "description": "For large groups, Amruta Travels provides a 50-seater bus for airport transfers in Pune. This bus is equipped with comfortable seating, air conditioning, and ample luggage space, making it ideal for group travel to and from the airport."
    },
    {
      "name": "AC Bus Rental for Airport Transfer Pune",
      "description": "Amruta Travels offers AC bus rental for airport transfers in Pune, ensuring a cool and comfortable journey to your destination. Whether you're traveling alone or with a group, our air-conditioned buses provide a relaxing experience, especially in Pune’s hot weather."
    },
    {
      "name": "Airport Bus Hire Near Pune Station",
      "description": "Looking for an airport bus near Pune station? Amruta Travels offers bus hire services that conveniently pick you up near Pune station and take you to the airport, ensuring a seamless connection between transport hubs."
    },
    {
      "name": "Affordable Airport Bus Hire Pune",
      "description": "Amruta Travels offers affordable airport bus hire services in Pune, ensuring that your airport transfer is both cost-effective and comfortable. We have a wide range of buses at different price points to meet your budget needs."
    },
    {
      "name": "Budget Bus Rental for Airport Transfers Pune",
      "description": "For those looking for budget-friendly travel options, Amruta Travels offers affordable bus rentals for airport transfers in Pune. Our budget buses are perfect for groups looking for a cost-effective yet comfortable travel solution."
    },
    {
      "name": "Pune to Mumbai Airport Bus Hire",
      "description": "Traveling from Pune to Mumbai Airport? Amruta Travels offers convenient and timely bus hire services between Pune and Mumbai Airport. Our buses ensure a smooth and comfortable journey, complete with experienced drivers for your peace of mind."
    },
    {
      "name": "Pune Mumbai Airport Drop Bus Service",
      "description": "For a stress-free journey from Pune to Mumbai Airport, book our Pune Mumbai Airport Drop Bus Service. We offer comfortable and reliable buses that ensure timely arrival at Mumbai Airport, whether for a flight or a special event."
    },
    {
      "name": "Pune Airport Bus Hire Service",
      "description": "Amruta Travels offers comprehensive airport bus hire services in Pune. Our service includes both pickup and drop-off from Pune Airport, providing convenient and safe transport for individuals and large groups alike."
    }
  ],
  "tableData": [
    ["Airport Bus Hire in Pune", "Bus Rental For Airport Transfers Pune"],
    ["Hire a Bus for Airport Service Pune", "Pune Airport Transfer Bus Rental"],
    ["Airport Pickup Bus Hire in Pune", "Airport Drop-off Bus Rental Pune"],
    ["26 Seater Bus for Airport Transfer Pune", "25 Seater Airport Bus Rental Pune"],
    ["32 Seater Airport Bus Hire Pune", "50 Seater Bus for Airport Transfers Pune"],
    ["AC Bus Rental for Airport Transfer Pune", "Airport Bus Hire Near Pune Station"],
    ["Affordable Airport Bus Hire Pune", "Budget Bus Rental for Airport Transfers Pune"],
    ["Pune to Mumbai Airport Bus Hire", "Pune Mumbai Airport Drop Bus Service"],
    ["Pune Airport Bus Hire Service", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Bus Hire Service for Pune Airport Transfers",
    "WhyChoosedescription": "Amruta Travels offers dependable and punctual bus hire services for group transfers to and from Pune Airport. Whether it’s a corporate group, wedding guests, tour travelers, or student delegations, our airport transport services are designed to ensure smooth coordination and timely pick-up/drop-off for all travelers. Enjoy stress-free airport travel with our experienced logistics support and fleet of well-maintained buses."
  },
  {
    "WhyChooseheading": "Perfect for Group Arrivals, Departures, and Flight Connections",
    "WhyChoosedescription": "Managing group airport transfers can be challenging—especially with luggage and varied arrival timings. Our Pune Airport bus hire service is ideal for group airport pickups, conference groups, event attendees, and international tourists. We coordinate your airport schedule precisely to ensure no delays, even for early morning or late-night flights."
  },
  {
    "WhyChooseheading": "Wide Range of Buses for Small to Large Groups",
    "WhyChoosedescription": "From 17-seater minibuses to 50-seater coaches, we offer a versatile fleet that suits every group size. Our vehicles are equipped with comfortable seating, air conditioning (or Non-AC as required), and luggage space to accommodate airport baggage. Whether it’s a small family or a full corporate team, we have the right vehicle for your needs."
  },
  {
    "WhyChooseheading": "Professional Drivers with Airport Coordination Experience",
    "WhyChoosedescription": "Our drivers are experienced with airport routes, terminal logistics, and real-time traffic adjustments. They are punctual, courteous, and well-trained to assist with timely pick-up and drop-off. For group arrivals, we also coordinate with travel managers to track flight statuses and avoid delays."
  },
  {
    "WhyChooseheading": "Custom Pickup and Drop Points in Pune City",
    "WhyChoosedescription": "Amruta Travels allows complete flexibility in airport transfers. Whether you need group pickups from multiple hotels, corporate offices, wedding venues, or institutions across Pune, we ensure efficient routing and scheduling so that everyone arrives at the airport comfortably and on time."
  },
  {
    "WhyChooseheading": "Affordable Pricing and Transparent Billing",
    "WhyChoosedescription": "Our Pune Airport bus hire rates are competitively priced and fully transparent. There are no hidden charges—your fare includes driver allowance, fuel, tolls, and taxes. We also offer corporate billing options and customized packages for frequent airport transfer requirements."
  },
  {
    "WhyChooseheading": "Clean, Sanitized Buses with Spacious Interiors",
    "WhyChoosedescription": "All our buses are cleaned and sanitized before every trip. Interiors are comfortable and spacious, with ample room for passengers and luggage. Especially important for airport journeys, our vehicles are maintained to high standards of hygiene and functionality."
  },
  {
    "WhyChooseheading": "24/7 Availability and Easy Booking Process",
    "WhyChoosedescription": "Airport transfers can be required at any hour. That’s why our services are available 24/7 to match flight schedules. Booking is easy—online, via call, or by visiting our office. Our customer support team is always ready to help you coordinate your airport travel smoothly."
  }
]



















    }

const faqData = [
  {
    question: 'Do you provide bus hire service for Pune Airport pickup and drop?',
    answer: 'Yes, Amruta Travels offers reliable and timely bus hire services for Pune Airport transfers. Whether it’s for a group arrival or departure, we ensure punctual pickup and drop services with experienced drivers.',
  },
  {
    question: 'What types of buses are available for Pune Airport transfers?',
    answer: 'We offer a range of buses including 17, 32, 35, 40, 45, and 50-seater options. Both AC and non-AC buses are available, along with luxury and semi-luxury variants depending on your requirements.',
  },
  {
    question: 'Is airport transfer service available 24/7?',
    answer: 'Yes, our airport transfer services are available 24/7. We cater to early morning or late-night flights to ensure your group travels stress-free, no matter the hour.',
  },
  {
    question: 'Can I book multiple pickup or drop-off points for an airport trip?',
    answer: 'Yes, we offer flexible routing. You can book multiple pickup or drop-off locations for airport transfers. Just share your schedule in advance and we’ll plan accordingly.',
  },
  {
    question: 'Is the bus equipped for luggage handling?',
    answer: 'Yes, our buses have ample luggage space, especially ideal for airport travel. Larger groups or travelers with heavy baggage can opt for coaches with extra storage capacity.',
  },
  {
    question: 'Do you offer airport transfer services for corporate clients or events?',
    answer: 'Absolutely. We specialize in corporate airport transfers, MICE events, and group movements. Our buses are perfect for transporting guests to and from Pune Airport efficiently.',
  },
  {
    question: 'How far in advance should I book the bus for airport pickup/drop?',
    answer: 'We recommend booking at least 24–48 hours in advance for guaranteed availability, especially during peak travel times or events. However, same-day bookings may be available based on fleet availability.',
  },
  {
    question: 'What is the pricing for airport bus hire in Pune?',
    answer: 'Pricing depends on the type of bus, distance to/from the airport, timing, and routing. Contact us with your travel details to get a clear and customized quote.',
  },
  {
    question: 'Why choose Amruta Travels for Pune Airport bus hire service?',
    answer: 'Amruta Travels is known for punctual, professional, and well-coordinated airport transfers. Our trained drivers, clean buses, and commitment to timing make us the preferred choice for group airport transportation.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Ritesh Patil',
    role: 'HR Manager, IT Company Pune',
    text: 'We hired a 35-seater bus for an airport pickup for our international team. Amruta Travels was on time and very professional. Great service and smooth experience!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Anjali Nene',
    role: 'Wedding Planner, Pune',
    text: 'We needed group transport for guests arriving at Pune Airport. Amruta Travels managed everything on time with clean buses and courteous staff. Highly dependable!',
    rating: 5,
  },
];



































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Airport Bus Hire Service",
  "image": "https://bushireinpune.com/assets/images/pune-airport-bus-hire.jpg",
  "description": "Book affordable and comfortable buses for airport transfers in Pune. Choose from a variety of bus options including 26-seater, 32-seater, and 50-seater AC buses. Amruta Travels offers reliable airport pickup and drop-off services, including buses for Pune to Mumbai airport transfers.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "2900"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2999",  // Adjust price based on distance or specific service
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/pune-airport-bus-hire-service"
  }
};



    return (
        <div>


<Helmet>
  <title>Call: +91 7353109555 | Pune Airport Bus Hire Service | Airport Transfer & Pickup | Amruta Travels</title>
  <meta 
    name="description" 
    content="Hire buses for airport transfers in Pune. Affordable AC buses for airport pickup and drop-off. Book 26, 32, 50-seater buses for Pune to Mumbai airport or local airport transfers." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/58.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Bushireserviceforpune;